export default {
    USER_ID: `NXygvd35CRXIFRWqu`, //userID
    TEMPLATE_ID: `template_el99y4n`, //templateID
    SERVICE_ID: `service_jw0y9ee` //serviceID
}